export interface UtmParams {
  source: string;
  medium: string;
  campaign: string;
  content?: string;
}

export const DEFAULT_UTM: UtmParams = {
  source: "altibbi-newsletter",
  medium: "email",
  campaign: "",
  content: "",
};

export function utmCampaignFromTitle(title: string): string {
  return title
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 60) || "newsletter";
}

export function utmMissing(utm: UtmParams | undefined): string[] {
  const u = utm ?? DEFAULT_UTM;
  const missing: string[] = [];
  if (!u.source.trim()) missing.push("utm_source");
  if (!u.medium.trim()) missing.push("utm_medium");
  if (!u.campaign.trim()) missing.push("utm_campaign");
  return missing;
}

export function appendUtm(href: string, utm: UtmParams | undefined, content?: string): string {
  const raw = href.trim();
  if (!raw.startsWith("http://") && !raw.startsWith("https://")) return raw;
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return raw;
  }
  const u = utm ?? DEFAULT_UTM;
  if (u.source.trim()) url.searchParams.set("utm_source", u.source.trim());
  if (u.medium.trim()) url.searchParams.set("utm_medium", u.medium.trim());
  if (u.campaign.trim()) url.searchParams.set("utm_campaign", u.campaign.trim());
  const c = (content || u.content || "").trim();
  if (c) url.searchParams.set("utm_content", c);
  return url.toString();
}
